import Decimal from "decimal.js"
import React, {
  CSSProperties,
  RefObject,
  useEffect,
  useRef,
  useState,
} from "react"

const NumberInput: React.FC<{
  name: string
  value?: number
  setValue: (value: number) => void
  style?: CSSProperties
  autoFocus?: boolean
  id: string
  isInlineBlockComponent?: boolean
  disabled?: boolean
  min?: number
  max?: number
  decimalPoint?: number
  step?: number
  required?: boolean
  placeholder?: string
  isFloat?: boolean
  readOnly?: boolean
  setInvalidMessage?: (value: string) => void
  ref?: RefObject<HTMLInputElement>
}> = ({
  name,
  value,
  setValue,
  style,
  id,
  disabled,
  min,
  max,
  isInlineBlockComponent,
  step,
  decimalPoint,
  required,
  autoFocus,
  placeholder,
  setInvalidMessage,
  readOnly,
  children,
  isFloat = false,
  ref,
}) => {
  const parentRef = useRef(null)
  const [isError, setIsError] = useState<boolean>(false)

  const setErrorMessage = (message: string) => {
    //エラーメッセージを返す
    if (setInvalidMessage ?? false) {
      setInvalidMessage!(message)
    }
  }

  function inValid(e: React.FocusEvent<HTMLInputElement>) {
    let message = ""
    let isErrorInner = false
    console.log(e.target.validity)
    if (e.target.validity.valueMissing) {
      isErrorInner = true
      message = `${name}は必須入力です。`
    } else if (e.target.validity.patternMismatch) {
      isErrorInner = true
      message = `${name}の入力形式を確認してください。`
    } else if (e.target.validity.tooLong) {
      isErrorInner = true
      message = `${name}の値が大きすぎます。`
    } else if (e.target.validity.tooShort) {
      isErrorInner = true
      message = `${name}の値が小さすぎます。`
    } else if (e.target.validity.rangeOverflow) {
      isErrorInner = true
      message = `${name}の値が指定された範囲を超えています。`
    } else if (e.target.validity.rangeUnderflow) {
      isErrorInner = true
      message = `${name}の値が指定された範囲を下回っています。`
    } else if (e.target.validity.stepMismatch) {
      isErrorInner = true
      message = `${name}の単位は${step}です。`
    }

    setErrorMessage(message)
    setIsError(isErrorInner)
  }

  const innerRef = React.createRef<HTMLInputElement>()

  useEffect(() => {
    if (autoFocus) {
      if (ref) {
        ref.current?.focus()
      } else {
        innerRef.current?.focus()
      }
    }
  }, [autoFocus, ref, innerRef])

  // placeHolderとfloatinglabel用
  const [isShowFloatingLabel, setIsShowFloatingLabel] = useState<boolean>()

  useEffect(() => {
    if (placeholder && value != null) {
      setIsShowFloatingLabel(true)
    } else {
      setIsShowFloatingLabel(false)
    }
  }, [placeholder, value])

  return (
    <>
      <div
        className={
          isInlineBlockComponent
            ? "floating-frame d-inline-block"
            : "floating-frame"
        }>
        {isShowFloatingLabel && (
          <span className="floating-label">{placeholder}</span>
        )}
        <div
          className={[
            "wj-control",
            "wj-content",
            "wj-dropdown",
            required ? "required_input" : "",
          ].join(" ")}
          ref={parentRef}>
          <div className="wj-template">
            <div className="wj-input">
              <div className="wj-input-group">
                <input
                  ref={ref ?? innerRef}
                  style={style}
                  id={id}
                  className={[
                    "wj-form-control",
                    "wj-form-content",
                    "number-input",
                    isError ? "is-error" : "",
                    readOnly ? "read-only" : "",
                  ].join(" ")}
                  disabled={disabled}
                  type="number"
                  value={value}
                  min={min}
                  max={max}
                  step={step}
                  readOnly={readOnly}
                  required={required}
                  placeholder={isShowFloatingLabel ? "" : placeholder ?? ""}
                  onChange={(e: any) => {
                    // 自動でnumberがstringに認識されているのでstring検知して強制的に変更
                    if (typeof e.target.value === "string") {
                      if (isFloat) {
                        if (e.target.value !== "") {
                          if (decimalPoint) {
                            let dp = 10
                            let v = new Decimal(e.target.value).toNumber()
                            for (let i = 1; i < decimalPoint; i++) {
                              dp = dp * 10
                            }
                            setValue(Math.trunc(v * dp) / dp)
                          } else {
                            setValue(new Decimal(e.target.value).toNumber())
                          }
                        } else {
                          setValue(NaN)
                        }
                      } else {
                        setValue(parseInt(e.target.value))
                      }
                    } else {
                      setValue(e.target.value)
                    }
                  }}
                  onInvalid={(e: any) => inValid(e)}
                />
                {children}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default NumberInput
